// Saving a consent before the action it guards.
//
// The action must not go ahead unless its consent was saved. `saveConsentFor` either answers the
// saved consent's id, which the action then sends to the server, or fails with
// `ConsentSaveFailedError`; a screen that gets that failure shows the retry message and does
// nothing else, leaving what the person entered in place.

import { saveConsent } from './api';
import { CONSENT_WORDINGS } from './consentWordings';

export const CONSENT_SAVE_FAILED_MESSAGE_ID = 'ConsentSave.failed';

export class ConsentSaveFailedError extends Error {
  constructor(cause) {
    super('The consent could not be saved.');
    this.name = 'ConsentSaveFailedError';
    this.cause = cause;
  }
}

// The server refused the action because the consent it names cannot be used for it.
export const isConsentRequiredRefusal = error =>
  error?.status === 403 && error?.error === 'consent_required';

const browserDevice = () =>
  (typeof navigator !== 'undefined' && navigator.userAgent) || 'unknown';

// Records the consent with the wording the screen shows for its type, and answers its id.
export const saveConsentFor = async (consentType, { candidateListingId, jobListingId, deviceUsed, consentText } = {}) => {
  let response;
  try {
    response = await saveConsent({
      consentType,
      consentText: consentText ?? CONSENT_WORDINGS[consentType],
      deviceUsed: deviceUsed ?? browserDevice(),
      ...(candidateListingId ? { candidateListingId } : {}),
      ...(jobListingId ? { jobListingId } : {}),
    });
  } catch (error) {
    throw new ConsentSaveFailedError(error);
  }
  const consentId = response?.consentId;
  if (!consentId) throw new ConsentSaveFailedError(null);
  return consentId;
};
